// App.D.on('ga:ready', function() {

    // console.log('ready');



let counters;

export class Counters {
    constructor() {
        this.init();
    }


    init() {
        // Просмотр страницы при использовании Pjax
        App.D.on('ga:dimension', function() {
            //const is_admin = window.is_admin;

            // window.dataLayer.push({
            //     'event': 'gtm-param',
            //     'gtm-param-name': 'dimension',
            //     'gtm-param-number': 1,
            //     'gtm-param-label': is_admin === 1 ? 'traffic_by_admin_1' : 'traffic_by_admin_0',
            //     'gtm-event-non-interaction': true
            // });
        });

        // Этот запускаем и при первой загрузке страницы
        App.D.trigger('ga:dimension');

        App.D.on('ga:pageview', function() {
            window.dataLayer.push({
                'event': 'gtm-ga-event',
                'gtm-event-category': 'pageview',
                'gtm-event-action': 'pageview',
                'gtm-event-label': document.location.pathname,
                'gtm-event-non-interaction': false
            });
        });



        // Клик на пункт меню и логотип
        // App.D.on('click', '.js-menu-list a, a.logo', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'menu',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.data('alias'),
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': $el.data('alias-ya'),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Клик на соцсети в меню
        // App.D.on('click', '.js-menu-socials a', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'menu',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.data('alias'),
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'menu_click_' + $el.data('alias'),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Клик на соцсети в других местах
        // App.D.on('click', '.js-socials a', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'social',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.data('alias'),
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'social_click_' + $el.data('alias'),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Клик на кнопку New Project в шапке
        // App.D.on('click', '.header .js-open-form, .js-menu .js-open-form', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'menu',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'new_project',
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'new_project_click',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Клик на кнопку New Project в футере
        // App.D.on('click', '.js-counter-open-form', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'footer',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'new_project',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Клик на email в шапке
        // App.D.on('click', '.js-counter-menu-email', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'menu',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'email',
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'menu_click_email',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Клик по email в футере
        // App.D.on('click', '.js-counter-email-footer', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'footer',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'email',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Клик на email в других местах
        // App.D.on('click', '.js-counter-email', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'email',
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'click_email',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        //// ГЛАВНАЯ

        // Главная: клик по ссылке About в промо-блоке
        // App.D.on('click', '.js-counter-promo-about', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'main_promo',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.text(),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Главная: клик по проекту
        // App.D.on('click', '.js-mp-projects-section .project-card__link', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'main_' + $el.closest('.js-mp-projects-section').data('alias'),
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.find('.project-card__title span').text(),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Главная: клик по cta
        // App.D.on('click', '.js-mp-counter-cta', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'main_' + $el.closest('.js-mp-projects-section').data('alias'),
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'block_cta',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Главная: клик по клиентам
        // App.D.on('click', '[data-barba-namespace="main"] .js-vault .unmarked-list a', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'main_clients',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.text(),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // ABOUT

        // About: клик по превью категории
        // App.D.on('click', '[data-barba-namespace="about"] a.multi-item', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'about_expertise',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.data('alias'),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // About: клик по ссылке на категорию
        // App.D.on('click', '[data-barba-namespace="about"] .js-counter-about-category', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'about_clients',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'category',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // About: клик по клиентам
        // App.D.on('click', '[data-barba-namespace="about"] .other-clients .unmarked-list a', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'about_clients',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.text(),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // About: клик по email для вакансий
        // App.D.on('click', '[data-barba-namespace="about"] .js-counter-email-career', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'about_vacancy',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'e-mail',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // About: клик по ссылке на сайт HR
        // App.D.on('click', '[data-barba-namespace="about"] .js-counter-hr', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'about_hr',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'hr.cpeople.ru',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // About: свайп слайдера наград
        // App.D.on('ga:sliderAwardsChange', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'about_awards',
        //         'gtm-event-action': 'swipe',
        //         'gtm-event-label': 'list',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        //// CATEGORY

        // Category: клик по карточкам
        // App.D.on('click', '[data-barba-namespace="category"] .preview-card', function() {
        //     const pageName = $(this).closest('.preview-cards').data('alias');

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'portfolio_' + pageName,
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': 'heading_blocks',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Category: клик по кейсу
        // App.D.on('click', '[data-barba-namespace="category"] .project-card__link', function() {
        //     const $el = $(this);
        //     const index = $el.index('.project-card__link') + 1;

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'project_link',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.find('.project-card__title span').text(),
        //         'gtm-event-value': index,
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'project_click_external',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Category: клик по клиентам
        // App.D.on('click', '[data-barba-namespace="category"] .other-projects .unmarked-list a', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'project_link_footer',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.text(),
        //         'gtm-event-value': 0,
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'project_click_external',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        //// CASE

        // Case: клик по ссылке на проект
        // App.D.on('click', '[data-barba-namespace="case"] .js-counter-project-external', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'project_link_external',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': App.H.find('.js-counter-project-title').first().text(),
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'project_click_external',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Case: клик по ссылке Close Project
        // App.D.on('click', '.js-counter-close-project', function() {
        //     window.dataLayer.push({
        //         "event": "gtm-ga-event",
        //         "gtm-event-category": "link_close_project",
        //         "gtm-event-action": "click",
        //         "gtm-event-label": App.H.find('.js-counter-project-title').first().text(),
        //         "gtm-event-non-interaction": false
        //     });
        // });


        // Case: клик по ссылке Next Project
        // App.D.on('click', '.js-next-case-link', function() {
        //     window.dataLayer.push({
        //         "event": "gtm-ga-event",
        //         "gtm-event-category": "next_project_link",
        //         "gtm-event-action": "click",
        //         "gtm-event-label": App.H.find('.js-counter-project-title').last().text(),
        //         "gtm-event-non-interaction": false
        //     });
        // });

        // Case: клик по ссылкам Other Projects
        // App.D.on('click', '.js-counter-other-project', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'project_' + App.H.find('.js-counter-project-title').text() + '_other_cases',
        //         'gtm-event-action': 'click',
        //         'gtm-event-label': $el.text(),
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Case: пользователь увидел не меньше 30% картинки кейса
        // App.D.on('ga:portfolio:seen', function(event, el) {
        //     const name = $(el).siblings('.js-project-card-title').find('span').text();
        //     const index = $(el).index('.js-project-card-img') + 1;

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'project_view',
        //         'gtm-event-action': index,
        //         'gtm-event-label': name,
        //         'gtm-event-value': index,
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'project_view',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        //// NEW PROJECT

        // Form: фокус в любом поле
        // App.D.on('focus', '.js-form input, .js-form textarea, .js-form select', function() {
        //     const $el = $(this);

        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'contact_form',
        //         'gtm-event-action': 'focus',
        //         'gtm-event-label': $el.attr('name'),
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'focus_form_contact',
        //         'gtm-event-non-interaction': false
        //     });
        // });



        // Form: отправка
        // App.D.on('ga:sendForm', function() {
        //     window.dataLayer.push({
        //         'event': 'gtm-ga-event',
        //         'gtm-event-category': 'contact_form',
        //         'gtm-event-action': 'send',
        //         'gtm-event-non-interaction': false
        //     });

        //     window.dataLayer.push({
        //         'event': 'gtm-ym-event',
        //         'gtm-event-category': '',
        //         'gtm-event-action': '',
        //         'gtm-event-label': 'send_form_contact',
        //         'gtm-event-non-interaction': false
        //     });
        // });
    }
}

App.W.on('barba:afterEnter', () => {
    if(!counters){
        counters = new Counters();
    }
});

App.W.on('barba:leave', () => {
    try {
        // counters.destroy();
    } catch(error) {
        console.log(error);
    }
});
// });



// WEBPACK FOOTER //
// ./_src/js/modules/Counters.js